import React from "react";
import "./nasdaq.scss";
import { useTheme } from "../../../contexts/ThemeProvider";
import { LIGHT_THEME } from "../../../utils/constants";

const Nasdaq = () => {
  return (
    <section className="protocol nasaqdd">
      <div className="custom-container protocol_main">
        <div className="protype">
          <div className="protocol_left">
            <h3 className="about_common_heading">Nasdaq Recognition</h3>
            <p className="about_p">
              Rain protocol is backed by Nasdaq-listed Enlivex (ENLV), a public company operating at the intersection of quality longevity therapeutics and prediction market infrastructure.
              <span>
                Through a dual-engine structure, Enlivex combines clinical development of Allocetra™ with a RAIN-based treasury strategy, positioning itself as a public market vehicle with exposure to the expanding prediction markets ecosystem.
              </span>
            </p>
          </div>
          <img src="\assets\nasdaq.png" className="imgggproo" />
        </div>

      </div>
    </section>
  );
};

export default Nasdaq;
